import { compose, mdsWidget } from 'dojo/_base/declare';
import template from './TrainTransferBookedForForm.html?raw';

import _WidgetBaseSP from 'more/_WidgetBaseSP';
import HintBox from '../../../../../../moreCore/UI/HintBox/HintBox';
import Edit from '../../../../../../moreCore/UI/Edit/Edit';

class TrainTransferBookedForForm extends compose(_WidgetBaseSP) {
    templateString: any = template;

    private locationStartInput: MdsLax<InstanceType<typeof HintBox>>;
    private locationEndInput: MdsLax<InstanceType<typeof HintBox>>;
    private transportationCodeInput: MdsLax<InstanceType<typeof Edit>>;

    getData() {
        var data = {
            location_start: this.locationStartInput.getValue(),
        }
    }

    setData(data) {
        console.log(data);

        this.locationStartInput.setValue(data.ref_vt_travel.ref_location_start, true);
        this.locationEndInput.setValue(data.ref_vt_travel.ref_location_end, true);
        this.transportationCodeInput.setValue(data.ref_vt_travel.transportation_code, true);

      
    }

    postCreate(): void {
        super.postCreate.apply(this, arguments as any);

        this.disableNode(this.transportationCodeInput.domNode, true);

    }

    startup(): void {
        super.startup.apply(this, arguments as any);
    }
}

export default mdsWidget(TrainTransferBookedForForm);